import { DecodedToken } from '@supsupclub/types';
import { useQuery } from '@tanstack/react-query';
import { jwtDecode } from 'jwt-decode';

import { fetchProfile } from '../endpoints';
import { useAuthStore } from '../stores/auth-store';

export const isUSCEmail = (email: string) =>
  email.startsWith('usc-') && email.includes('@supsupclub.com');

export const useAuth = () => {
  const { token, setToken } = useAuthStore((state) => state);
  const decoded: DecodedToken | null = token ? jwtDecode(token) : null;
  const isLoggedIn = !!token;

  const {
    data: profile,
    isFetching: isProfileLoading,
    isError,
  } = useQuery({
    queryKey: ['FETCH_PROFILE'],
    queryFn: () => {
      return fetchProfile(decoded?._id || '');
    },
    enabled: isLoggedIn && !!decoded?._id,
    staleTime: Infinity,
  });
  const isAdmin = decoded?.role === 'ADMIN';
  const isSuperadmin = decoded?.role === 'SUPERADMIN';
  const isUSCAccount = isUSCEmail(profile?.email || '');

  return {
    isLoggedIn,
    isProfileLoading,
    profile,
    token,
    setToken,
    isError,
    isAdmin,
    isUSCAccount,
    isSuperadmin,
  };
};
